import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import AddBill from './pages/AddBill';
import ViewBills from './pages/ViewBills';
import GSTBills from './pages/GSTBills';
import GSTConfig from './pages/GSTConfig';
import OnlinePaymentsReport from './pages/OnlinePaymentsReport';
import BranchExpenses from './pages/BranchExpenses';
import OwnerExpenses from './pages/OwnerExpenses';
import CashHandover from './pages/CashHandover';
import CashBookings from './pages/CashBookings';
import UserManagement from './pages/UserManagement';
import MasterData from './pages/MasterData';
import Reports from './pages/Reports';
import ItemDetailedReport from './pages/ItemDetailedReport';
import WebsiteBookings from './pages/WebsiteBookings';
import Layout from './components/Layout';
import { AuthProvider, useAuth } from './context/AuthContext';
import './App.css';

const PrivateRoute = ({ children, adminOnly = false }) => {
  const { user, token, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
      </div>
    );
  }
  
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  
  if (adminOnly && user?.role !== 'admin') {
    return <Navigate to="/" replace />;
  }
  
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/add-bill"
            element={
              <PrivateRoute>
                <Layout>
                  <AddBill />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/edit-bill/:billId"
            element={
              <PrivateRoute>
                <Layout>
                  <AddBill />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/view-bills"
            element={
              <PrivateRoute>
                <Layout>
                  <ViewBills />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/branch-expenses"
            element={
              <PrivateRoute>
                <Layout>
                  <BranchExpenses />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/owner-expenses"
            element={
              <PrivateRoute adminOnly>
                <Layout>
                  <OwnerExpenses />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/cash-handover"
            element={
              <PrivateRoute>
                <Layout>
                  <CashHandover />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/cash-bookings"
            element={
              <PrivateRoute>
                <Layout>
                  <CashBookings />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/users"
            element={
              <PrivateRoute adminOnly>
                <Layout>
                  <UserManagement />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/master-data"
            element={
              <PrivateRoute adminOnly>
                <Layout>
                  <MasterData />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <PrivateRoute adminOnly>
                <Layout>
                  <Reports />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/report/cakes"
            element={
              <PrivateRoute>
                <Layout>
                  <ItemDetailedReport itemType="cake" />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/report/decorations"
            element={
              <PrivateRoute>
                <Layout>
                  <ItemDetailedReport itemType="decoration" />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/report/food-beverages"
            element={
              <PrivateRoute>
                <Layout>
                  <ItemDetailedReport itemType="food" />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/report/miscellaneous"
            element={
              <PrivateRoute>
                <Layout>
                  <ItemDetailedReport itemType="miscellaneous" />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/gst-bills"
            element={
              <PrivateRoute>
                <Layout>
                  <GSTBills />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/gst-config"
            element={
              <PrivateRoute adminOnly>
                <Layout>
                  <GSTConfig />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/online-payments"
            element={
              <PrivateRoute>
                <Layout>
                  <OnlinePaymentsReport />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/website-bookings"
            element={
              <PrivateRoute>
                <Layout>
                  <WebsiteBookings />
                </Layout>
              </PrivateRoute>
            }
          />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
